export default __webpack_public_path__ + "static/media/rambouillet21.f1d44a97.jpg";